<section class="mg-app-footer">
    <p class="dev-platform">
        <a href="https://effieturkiye.org" target="_blank">effieturkiye.org</a>
    </p>
</section>